import { endSession, getAccessToken } from '../auth/session';
import { ApiError, request } from './http';

/** GET with the access token. A 401 means the session is over: the app goes back to login. */
export async function staffGet<T>(path: string): Promise<T> {
  try {
    return await request<T>(path, { token: getAccessToken() });
  } catch (error) {
    if (error instanceof ApiError && error.status === 401) {
      endSession();
    }
    throw error;
  }
}
